<script setup lang="ts">
import {
  SCHEDULED_FREQUENCIES,
  SCHEDULED_FREQUENCIES_OPTIONS
} from '@/app/core/services/processes'
import { ChevronDownIcon } from 'front-library'
import { ref } from 'vue'

type Item = {
  code: string
  name: string
}

defineProps<{
  items: Item[]
  modelValue: SCHEDULED_FREQUENCIES | SCHEDULED_FREQUENCIES_OPTIONS
}>()

const isOpen = ref(false)

const emit = defineEmits(['update:modelValue'])

const emitUpdate = (item: Item) => {
  isOpen.value = false
  emit('update:modelValue', item.code)
}
</script>

<template>
  <div class="relative flex items-center">
    <div
      @click.prevent="isOpen = true"
      class="flex items-center rounded-xl cursor-pointer">
      {{ items.find(item => item.code === modelValue.toString())?.name }}
      <ChevronDownIcon class="w-4 h-4 cursor-pointer" />
    </div>
    <div
      v-if="isOpen && items.length > 0"
      class="absolute top-4 bg-white rounded-md shadow-lg py-2 flex flex-col gap-2"
      @mouseleave="isOpen = false">
      <span
        class="p-2 hover:bg-gray-50 cursor-pointer"
        v-for="(item, index) in items"
        :key="index"
        @click.prevent="emitUpdate(item)">
        {{ item.name }}
      </span>
    </div>
  </div>
</template>
